import { render, staticRenderFns } from "./modal-webhook.vue?vue&type=template&id=453bb468&scoped=true"
import script from "./modal-webhook.vue?vue&type=script&lang=js"
export * from "./modal-webhook.vue?vue&type=script&lang=js"
import style0 from "./modal-webhook.vue?vue&type=style&index=0&id=453bb468&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453bb468",
  null
  
)

export default component.exports